export default "/images/ico-calendar.svg?f04317fb538d5d0dd1fa3c5efa927a8a";